import { FieldMaskEnricher } from './fieldMaskEnricher';
import { ItemEnricher } from './model';
import { PhoneFieldLocalizer } from './phoneFieldLocalizer';
import { SdkSessionDataEnricher } from './sdkSessionDataEnricher';
import { SelectTypeFieldEnricher } from './selectTypeFieldEnricher';

const ITEM_ENRICHERS: ItemEnricher[] = [
  FieldMaskEnricher,
  PhoneFieldLocalizer,
  SelectTypeFieldEnricher,
  SdkSessionDataEnricher,
];

export const GeneralConfigurationItemEnricher: ItemEnricher = {
  shouldEnrich: (_, __) => true,
  enrich: (field, context) => {
    ITEM_ENRICHERS.forEach((enricher) => {
      if (enricher.shouldEnrich(field, context)) {
        enricher.enrich(field, context);
      }
    });
  },
};
